<template>
  <div class="vue-tempalte">
<div class="App" :class="{ 'is-login': !isNotLogin }">


      <Tabnav  v-if="isNav"/>
      <vue3-confirm-dialog></vue3-confirm-dialog>

      <div class="app-scroll-area">
        <div :class="[!isNotLogin ? '' : 'inner-block', 'app-shell-inner']">
          <div  :class="[!isNav||!isHome ? '' : ' app-shell-row', 'row g-0']">


            <div class="col-2 notmobile app-shell-col" style="    position: sticky;
    top: 0px;">


              <Sidebar v-if="isTab" />

             
            </div>
                          <SidebarMobile v-if="isNav && !isHomeScreen"/>

            <div :class="[isTab && 'col-lg-10 col-sm-12']" class="p-0 app-shell-col">

              <!-- <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
              </keep-alive> -->
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Tabnav from './components/Tabnav.vue'
import { connectPageToApp, isFacebookAuthError, PENDING_KEY } from '@/utils/connectPage'
import { redirectToLogin } from '@/utils/sessionExpired'
import Sidebar from './components/Sidebar.vue';
import SidebarMobile from "@/components/SidebarMobile.vue"

export default {
  components: { Tabnav, Sidebar,SidebarMobile },
  async mounted() {
    console.log(  this.$route.name)
    // ✅ รอให้ router resolve route ปัจจุบันก่อน
    await this.$router.isReady()

    const publicPages = ['terms', 'privacy', 'login', 'register']

    // ถ้าเป็นหน้า public ไม่ต้องทำอะไรเลย
    if (publicPages.includes(this.$route.name)) return

    const isAuthenticated = this.$storex.getters.getToken
    if (isAuthenticated) {
      const { uid } = this.$storex.getters.getUserData
      try {
        const getUser = await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/user/`, { uid })
        if (!getUser.data.status) {
          redirectToLogin()
          return
        }
      } catch (err) {
        // 401 ถูกจัดการใน axios interceptor (main.js) แล้ว — error อื่น (เน็ตสะดุด) ไม่ต้องเตะออกจากระบบ
        console.warn('ตรวจสอบผู้ใช้ไม่สำเร็จ', err)
      }
    }

    const pageData = this.$storex.getters.getPageData
    if (!pageData?.id) {
      this.$router.push('/')
      return
    }

    try {
      await this.$storex.dispatch("featureModule/loadFeatures")
      await this.$storex.dispatch("pageModule/loadPageInfo", pageData.id)
      this.$storex.dispatch("pageModule/listenPageInfoRealtime", pageData.id)
    } catch (err) {
      console.log(err)
    }

    // ✅ ใหม่ — ตอนเลือกเพจเชื่อมต่อเพจกับแอป (subscribe webhook) ไม่สำเร็จ → ลองใหม่เบื้องหลัง
    // (ดู utils/connectPage.js / HomeScreen.vue choosePage) ถ้าไม่ต่อสำเร็จ แชท/คอมเมนต์ของเพจจะไม่เข้าระบบ
    this.retryPendingPageConnect(pageData.id)
  },






  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    if (this.unwatch) this.unwatch();
  },
  computed: {
    // a computed getter
    token: function () {
      // `this` points to the vm instance
      return localStorage.getItem('jwtToken')
    },
    isNotLogin: function () {
      // Compare the current route's name with the provided name
      return this.$route.name != 'login';
    },
    isTab: function () {
      // แสดง Sidebar ทุกหน้าที่อยู่ในโซน dashboard (ก่อนหน้านี้ผูกไว้กับหน้า post หน้าเดียว)
      return this.$route.path.startsWith('/dashboard/');
    },
     isNav: function () {
      // แสดง Sidebar ทุกหน้าที่อยู่ในโซน dashboard (ก่อนหน้านี้ผูกไว้กับหน้า post หน้าเดียว)
      return !this.$route.path.startsWith("/login");
    },

     isHome: function () {
      // แสดง Sidebar ทุกหน้าที่อยู่ในโซน dashboard (ก่อนหน้านี้ผูกไว้กับหน้า post หน้าเดียว)
      console.log(!this.$route.path.startsWith("/home"))
      return !this.$route.path.startsWith("/");
    },
    isHomeScreen: function () {
      // ✅ ใหม่ — ใช้เช็คเฉพาะหน้า HomeScreen (route name 'home') เพื่อซ่อน SidebarMobile
      // แยกออกมาจาก isHome เดิม (ซึ่งเช็คด้วย path.startsWith("/") ที่ true เสมอ และยังถูกใช้
      // ที่อื่นในเทมเพลตอยู่ — ไม่แก้ isHome ตรงๆ เพื่อไม่ให้กระทบ layout จุดอื่นโดยไม่ตั้งใจ)
      return this.$route.name === "home";
    },
    
    history() {
      return this.$storex.getters.getHistory || [];
    },
    menu() {
      const staticMenu = [
        { href: '/home', title: 'Home', icon: 'fa fa-user' },
      ];
      const historyList = Array.isArray(this.history) ? this.history : [];

      const historyMenu = historyList.map(h => ({
        href: `/editor/${h.id}`,
        title: `${(h.title || '').slice(0, 32)}...`,
        icon: 'fa fa-history',
        canDelete: true, // << เพิ่ม property นี้
        id: h.id // สำหรับลบ
      }));

      return [
        ...staticMenu,
        ...(historyMenu.length > 0 ? [{ title: 'Document' }, ...historyMenu] : []),
      ];
    }

  },
  data() {
    return {
      dropdownOpen: null, // index ของ dropdown ที่เปิด
    }
  },
  methods: {
    async retryPendingPageConnect(pageId) {
      if (localStorage.getItem(PENDING_KEY) !== pageId) return
      const fbAccessToken = this.$storex.getters.getFacebookToken
      for (const delay of [2000, 6000, 15000]) {
        await new Promise((r) => setTimeout(r, delay))
        try {
          await connectPageToApp(this.$http, pageId, fbAccessToken)
          localStorage.removeItem(PENDING_KEY)
          console.log("✅ เชื่อมต่อเพจกับแอปสำเร็จ (ลองใหม่เบื้องหลัง)")
          return
        } catch (err) {
          console.warn("เชื่อมต่อเพจกับแอปยังไม่สำเร็จ", err.response?.data || err)
          if (isFacebookAuthError(err)) break
        }
      }
      this.$swal.fire({
        title: "ยังเชื่อมต่อเพจกับระบบไม่สำเร็จ",
        text: "ข้อความแชทและคอมเมนต์ของเพจอาจยังไม่เข้าระบบ กรุณากลับไปหน้าเลือกเพจแล้วเลือกเพจนี้อีกครั้ง ถ้ายังไม่ได้ ให้ออกจากระบบแล้วเข้าสู่ระบบใหม่",
        icon: "warning",
      })
    },
    toggleDropdown(index) {
      this.dropdownOpen = this.dropdownOpen === index ? null : index;
    },
    renameItem(item) {
      const newTitle = prompt('Rename to:', item.title);
      if (newTitle) {
        this.$storex.commit('renameHistoryById', { id: item.id, title: newTitle });
      }
      this.dropdownOpen = null;
    },
    removeItem(item) {


      console.log(item)
      this.$confirm(
        {
          message: 'Are you sure?',
          button: {
            no: 'No',
            yes: 'Yes'
          },

          callback: confirm => {
            if (confirm) {
              this.removeHistory(item.id)
            }
            else {
              this.dropdownOpen = false
            }
          }
        }
      )
    },
    async removeHistory(id) {
      try {
        // เรียก API เพื่อลบข้อมูลใน backend (Firestore)
        await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/history/delete`, { id });

        // ก๊อปข้อมูลปัจจุบันจาก store มาแก้ไข
        const currentHistory = [...this.$store.getters.getHistory];

        // ลบ item ที่มี id ตรงกัน
        const updatedHistory = currentHistory.filter(item => item.id !== id);

        // อัปเดต Vuex store
        this.$store.dispatch("setHistory", updatedHistory);
        this.dropdownOpen = false
        console.log('✅ History deleted:', id);
      } catch (error) {
        console.error("❌ Failed to delete history:", error);
      }
    },
    handleClickOutside(event) {
      const dropdowns = document.querySelectorAll('.dropdown');
      let clickedInside = false;

      dropdowns.forEach(dropdown => {
        if (dropdown.contains(event.target)) {
          clickedInside = true;
        }
      });

      if (!clickedInside) {
        this.dropdownOpen = null;
      }
    },

  }

};
</script>
<style>
.App {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important;
  height: 100dvh !important;
  overflow: hidden !important;
}

.app-scroll-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

/* ต่อ chain ของความสูง 100% จาก app-scroll-area (ซึ่งคำนวณพื้นที่ที่เหลือจริงด้วย flex แล้ว)
   ลงไปถึง root element ของทุกหน้า เพื่อให้แต่ละหน้าใช้ height:100% ได้เลยโดยไม่ต้องเดา
   calc(100vh - ตัวเลขความสูง Tabnav) เองอีกต่อไป (ต้นเหตุที่ทำให้หน้า Chat คำนวณผิดพลาด) */
.app-shell-inner,
.app-shell-row,
.app-shell-col {
  height: 100%;
  /* ✅ ใหม่ — เพิ่ม min-height: 0 (เดิมไม่มี) — .app-shell-row เป็น flex container (จาก Bootstrap
     .row) และ .app-shell-col เป็น flex item ของมัน แต่ flex item ค่า default ของ min-height คือ
     "auto" (แปลว่า "สูงได้เท่าที่ content ต้องการเป็นอย่างน้อย") ทำให้หน้าที่ content สูงเกิน viewport
     (เช่น ManagerChatScreen ตอนมีข้อความในแชทเยอะๆ) ดัน .app-shell-col ให้สูงเกิน 100% ของพื้นที่จริง
     ทั้งที่ตั้งใจให้ overflow-y:auto ข้างในหน้านั้นเลื่อนแทน ผลคือทั้งหน้า (.app-scroll-area) เลื่อนแทน
     ไม่ใช่แค่ส่วนข้อความ (บั๊กเดียวกันกับที่เคยแก้ไปแล้วเฉพาะจุดใน ManagerChatScreen.vue ที่ระดับ
     Bootstrap column ของมันเอง — แต่จุดนี้อยู่สูงกว่านั้นอีกชั้นใน App.vue เลยไม่เคยถูกแก้มาก่อน) */
  min-height: 0;
  /* display: flex;
  justify-content: center; */
}

.app-shell-col>* {
  height: 100%;
  min-height: 0; /* ✅ ใหม่ — ต่อ chain ลงไปถึง root element ของทุกหน้า (เช่น ManagerChatScreen) ด้วย */
}

@media (max-width: 1250px) {

  .notmobile {
    display: none !important
  }
  .col-lg-10{
    width: 100% !important;
  }

  .mobile {
    display: flex !important
  }
}
</style>